import React from "react";
import strategize from "../Images/Strategize_icon.svg";
import Discover from "../Images/Discover_icon.svg";
import Connect from "../Images/Connect_icon.svg";
import Implement from "../Images/Implement_icon.svg";
import { useTranslation } from "react-i18next";

export const EasyFlow = () => {
  const { t, i18n } = useTranslation();

  // Check if current language is Arabic
  const isRTL = i18n.language === "ar";

  // Step data to map over
  const steps = [
    { number: "01", icon: strategize, title: t("easyFlow.step1Title") },
    { number: "02", icon: Discover, title: t("easyFlow.step2Title") },
    { number: "03", icon: Connect, title: t("easyFlow.step3Title") },
    { number: "04", icon: Implement, title: t("easyFlow.step4Title") },
  ];

  // If RTL, reverse the steps order
  const displayedSteps = isRTL ? [...steps].reverse() : steps;

  return (
    <div
      id="easyflow"
      className=""
      dir={isRTL ? "rtl" : "ltr"} // RTL or LTR for the whole container
    >
      <div className="p-15 flex flex-col items-center justify-center text-white font-semibold text-center font-sans">
        <div className="mt-20">
          <span className="flex justify-center flex-col items-center">
            <svg
              width="129"
              height="27"
              viewBox="0 0 129 27"
              fill="#ffffff"
              xmlns="http://www.w3.org/2000/svg"
              className="mb-6"
            >
              <rect width="4" height="27" fill="#ffffff" />
              <rect x="25" width="4" height="27" fill="#ffffff" />
              <rect x="50" width="4" height="27" fill="#ffffff" />
              <rect x="75" width="4" height="27" fill="#ffffff" />
              <rect x="100" width="4" height="27" fill="#ffffff" />
              <rect x="125" width="4" height="27" fill="#ffffff" />
            </svg>
          </span>
          <div className="text-xl text-white wow fadeInUp">{t("easyFlow.subtitle")}</div>
        </div>

        <div className="lg:text-6xl text-3xl font-bold wow fadeInUp font-geo text-[#EF3B3B] mt-4 mb-5">
          {t("easyFlow.title")}
        </div>

        <div className="text-xl font-semibold wow fadeInUp text-gray-400 mt-4 mb-5">
          {t("easyFlow.description")}
        </div>
      </div>

      {/* Steps section */}
      <div
        className={`flex flex-wrap justify-center font-sans ${
          isRTL ? "text-right" : "text-left"
        }`}
      >
        {displayedSteps.map((step) => (
          <div key={step.number} className="flex flex-col items-center p-10 max-w-xs">
            <img
              className="mx-auto mb-5 w-24 h-24 transition duration-300 ease-in-out transform hover:scale-105"
              src={step.icon}
              alt={`${step.title} icon`}
            />
            <div className="text-4xl font-semibold text-white text-center">
              <div className="mb-2">{step.number}</div>
              <div className="text-2xl leading-tight">{step.title}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EasyFlow;
